import { Link } from "@flat-ui";
import { runtimeConfig } from "@src/runtime-config";

/**
 * The `ContactSupport` component providing them with a direct link to contact support via email.
 */
export function ContactSupport(): JSX.Element {
  return (
    <Link href={`mailto:${runtimeConfig.mailSupportAddress}`} underline="none">
      <var>{runtimeConfig.mailSupportAddress}</var>
    </Link>
  );
}
